import { z } from 'zod/v4';
import { Provider } from '../payment-methods/index.js';
export var CollectorType;
(function (CollectorType) {
    CollectorType["CREDITOR"] = "CREDITOR";
    CollectorType["TENANT"] = "TENANT";
})(CollectorType || (CollectorType = {}));
export var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["FI"] = "FI";
    PaymentOptionType["IBAN"] = "IBAN";
    PaymentOptionType["SWIFT"] = "SWIFT";
    PaymentOptionType["BANKTRANSFER"] = "BANKTRANSFER";
    PaymentOptionType["REEPAY"] = "REEPAY";
    PaymentOptionType["FARPAY"] = "FARPAY";
    PaymentOptionType["MOBILE_PEOPLE"] = "MOBILE_PEOPLE";
    PaymentOptionType["LINK_TO_OWN_PAYMENT"] = "LINK_TO_OWN_PAYMENT";
})(PaymentOptionType || (PaymentOptionType = {}));
export const PaymentOptionTypeToProviderMap = {
    [PaymentOptionType.REEPAY]: Provider.Frisbii,
    [PaymentOptionType.FARPAY]: Provider.FarPay,
    [PaymentOptionType.MOBILE_PEOPLE]: Provider.MobilePeople,
};
export const genWebhookEventAPIPath = (tenantId, provider) => `/v1/${tenantId}/payment-methods/provider-events/${provider}`;
export var FIKSyntax;
(function (FIKSyntax) {
    FIKSyntax["CaseIdAndZero"] = "CaseIdAndZero";
    FIKSyntax["PrincipalReferenceId"] = "PrincipalReferenceId";
})(FIKSyntax || (FIKSyntax = {}));
const paymentOptionOrder = [
    PaymentOptionType.BANKTRANSFER,
    PaymentOptionType.FI,
    PaymentOptionType.SWIFT,
    PaymentOptionType.IBAN,
    PaymentOptionType.REEPAY,
    PaymentOptionType.FARPAY,
    PaymentOptionType.MOBILE_PEOPLE,
    PaymentOptionType.LINK_TO_OWN_PAYMENT,
];
const orderingIndex = (paymentOption) => Array.isArray(paymentOption)
    ? paymentOptionOrder.findIndex((k) => k === paymentOption.type)
    : -1;
export const getPaymentOptions = (options, currency) => {
    options = options.sort((a, b) => orderingIndex(b) - orderingIndex(a));
    const filteredOptions = options.reduce((acc, option) => {
        if (option.currencies == null ||
            (Array.isArray(option.currencies) && option.currencies.includes(currency))) {
            if (acc[option.type] == null)
                acc[option.type] = option;
        }
        return acc;
    }, {});
    return Object.values(filteredOptions).sort((a, b) => orderingIndex(b) - orderingIndex(a));
};
export var CommissionChains;
(function (CommissionChains) {
    CommissionChains["NcNp"] = "9860cf1a-b4d9-4d4e-a085-298c4781eca0";
    CommissionChains["NoCom"] = "22d11ef6-41cd-4e12-b9d0-f0678afde91b";
})(CommissionChains || (CommissionChains = {}));
export const InitiateDNSSchema = z.object({
    debtorWebBase: z.string().optional(),
    creditorWebBase: z.string().optional(),
    outboundEmail: z.string().email(),
});
//# sourceMappingURL=index.js.map